import {
  Box,
  Button,
  FormLabel,
  TextareaAutosize,
  Typography
} from '@mui/material';
import styled from 'styled-components';
import pallet from '../../../layouts/pallet';
import { PageWrapper } from '../../common/styled';

export const RoundedButton = styled(Button).attrs((props: any) => ({
  color: 'primary',
  style: {
    backgroundColor: props.backgroundColor,
    color: props.textColor,
    boxShadow: props.boxShadow
  }
}))<{
  backgroundColor?: string;
  textColor?: string;
  boxShadow?: string;
}>({
  width: '100%',
  maxWidth: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto',
    maxWidth: '200px'
  },
  textWrap: 'nowrap',
  fontSize: '15px !important'
});

export const StyledButton = styled(Button).attrs({
  variant: 'contained',
  color: 'primary'
})({});

export const PaymentOptionButton = styled(Button).attrs({
  variant: 'contained'
})<{
  disabled?: boolean;
}>(({ disabled }) => ({
  borderRadius: '6px !important',
  textWrap: 'nowrap',
  fontSize: '15px !important',
  minWidth: 'max-content !important',
  backgroundColor: `${
    disabled ? pallet.disabledGrey : pallet.greenBg
  } !important`,
  boxShadow: `0px 2px 4px 0px ${
    disabled ? pallet.disabledGrey : pallet.greenShadow
  } !important`,
  '@media (max-width: 600px)': {
    minWidth: '100% !important'
  }
}));

export const RemarksTitleText = styled(Typography).attrs({
  variant: 'h6',
  as: 'h6'
})(() => ({
  fontWeight: 'bold',
  fontSize: '18px !important',
  margin: 0
}));

export const RemarksTextAreaWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  '@media (max-width: 600px)': {
    flexDirection: 'column'
  }
}));

export const FormLabelText = styled(FormLabel).attrs({ as: 'h6' })(() => ({
  color: pallet.formLabelText,
  fontSize: 14,
  margin: 0,
  marginBottom: '8px'
}));

export const TextAreaField = styled(TextareaAutosize)(() => ({
  width: '100%',
  borderRadius: '8px',
  padding: '10px',
  borderColor: pallet.disabledBorder,
  '&:focus': {
    outline: 'none',
    borderColor: pallet.primary
  }
}));

export const AdmissionTabButtonWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '10px'
}));

export const SectionContainerWrapper = styled(PageWrapper)(() => ({
  minHeight: 'auto',
  paddingBlock: '12px',
  paddingInline: '24px'
}));

export const TitleBorderWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  '@media (max-width: 768px)': {
    // flexDirection: 'column',
    // alignItems: 'start'
    flexWrap: 'wrap'
  }
}));

export const SectionTitle = styled(Typography).attrs({
  variant: 'h6',
  as: 'h6'
})(() => ({
  margin: 0,
  fontWeight: 'bold',
  fontSize: '18px !important',
  textWrap: 'nowrap'
}));

export const DividerLine = styled(Box)(() => ({
  width: '100%',
  height: '1px',
  backgroundColor: pallet.dividerLine,
  '@media (max-width: 768px)': {
    display: 'none'
  }
}));

export const PaymentSchemeDetailTableHeader = styled(Box)(() => ({
  backgroundColor: pallet.grayBackground,
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${pallet.tableHeaderBorder}`,
  padding: '16px 20px',
  borderRadius: '9px',
  gap: '20px'
}));

export const PaymentSchemeDetailTableHeaderItem = styled(Box)<{
  itemIndex: number;
}>(({ itemIndex }) => ({
  width: '100%',
  position: 'relative',
  '&::after': {
    content: '""',
    display: 'block',
    height: '14px',
    width: '2px',
    backgroundColor: pallet.tableHeaderBorder,
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)'
  },
  flex: itemIndex === 4 || itemIndex === 5 ? 0.5 : 1.5,
  '&:last-of-type::after': { display: 'none' }
}));

export const AddMoreButton = styled(Button).attrs((props: any) => ({
  variant: 'contained',
  color: 'primary',
  style: {
    backgroundColor: props.backgroundColor,
    color: props.textColor
  }
}))<{
  backgroundColor?: string;
  textColor?: string;
}>({
  width: '100%',
  maxWidth: '100%',
  borderRadius: '6px !important',
  '@media (min-width:600px)': {
    width: 'auto',
    maxWidth: '200px'
  },
  textWrap: 'nowrap',
  fontSize: '15px !important',
  color: `${pallet.primary} !important`,
  backgroundColor: `${pallet.hoverBlue} !important`
});

export const FormFItemWrapper = styled(Box)(() => ({
  marginBlock: '16px',
  border: `2px solid ${pallet.border}`,
  borderRadius: '9px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 20px'
}));

export const FormFLinkText = {
  color: pallet.primary,
  textDecoration: 'none',
  fontWeight: 700,
  fontSize: '14px'
};

export const PaymentSchemeInstallmentRowWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: '20px',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '4px',
  marginBottom: '4px'
}));

export const PaymentSchemeInstallmentRowItem = styled(Box)(() => ({
  flex: '12px',
  maxWidth: '156px'
}));

export const SearchInputWrapper = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  alignItems: 'flex-end',
  width: '100%',
  '@media (max-width: 900px)': {
    flexDirection: 'column',
    gap: 16
  },
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    gap: 12
  }
}));
